// For Custom Javascript

// Cart Quantity Change


jQuery(function() {
  return $(".carousel-image").click(function() {
    var source = $(this).attr('src');
    $("#ProductPhotoImg").attr("src", source);
    return false;
  });
});

jQuery(function() {
  return $("#description-toggle").click(function() {
    $(this).addClass('active');
    $("#material-toggle").removeClass('active');
    $("#size-toggle").removeClass('active');
    $("#description-text").removeClass('hidden');
    $("#material-text").addClass('hidden');
    $("#size-text").addClass('hidden');
    return false;
  });
});

jQuery(function() {
  return $("#material-toggle").click(function() {
    $(this).addClass('active');
    $("#description-toggle").removeClass('active');
    $("#size-toggle").removeClass('active');
    $("#material-text").removeClass('hidden');
    $("#description-text").addClass('hidden');
    $("#size-text").addClass('hidden');
    return false;
  });
});

jQuery(function() {
  return $("#size-toggle").click(function() {
    $(this).addClass('active');
    $("#description-toggle").removeClass('active');
    $("#material-toggle").removeClass('active');
    $("#size-text").removeClass('hidden');
    $("#description-text").addClass('hidden');
    $("#material-text").addClass('hidden');
    return false;
  });
});
